/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OperatoreDTO
 */
export interface OperatoreDTO {
    /**
     * 
     * @type {string}
     * @memberof OperatoreDTO
     */
    enteId?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreDTO
     */
    cognome?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreDTO
     */
    codiceFiscale?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreDTO
     */
    nazioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreDTO
     */
    regioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreDTO
     */
    provinciaId?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreDTO
     */
    comuneId?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreDTO
     */
    regione?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreDTO
     */
    provincia?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreDTO
     */
    comune?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreDTO
     */
    telefono?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreDTO
     */
    cellulare?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreDTO
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OperatoreDTO
     */
    hasUserId?: boolean;
}

/**
 * Check if a given object implements the OperatoreDTO interface.
 */
export function instanceOfOperatoreDTO(value: object): value is OperatoreDTO {
    return true;
}

export function OperatoreDTOFromJSON(json: any): OperatoreDTO {
    return OperatoreDTOFromJSONTyped(json, false);
}

export function OperatoreDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperatoreDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'enteId': json['enteId'] == null ? undefined : json['enteId'],
        'nome': json['nome'] == null ? undefined : json['nome'],
        'cognome': json['cognome'] == null ? undefined : json['cognome'],
        'codiceFiscale': json['codiceFiscale'] == null ? undefined : json['codiceFiscale'],
        'nazioneId': json['nazioneId'] == null ? undefined : json['nazioneId'],
        'regioneId': json['regioneId'] == null ? undefined : json['regioneId'],
        'provinciaId': json['provinciaId'] == null ? undefined : json['provinciaId'],
        'comuneId': json['comuneId'] == null ? undefined : json['comuneId'],
        'regione': json['regione'] == null ? undefined : json['regione'],
        'provincia': json['provincia'] == null ? undefined : json['provincia'],
        'comune': json['comune'] == null ? undefined : json['comune'],
        'email': json['email'] == null ? undefined : json['email'],
        'telefono': json['telefono'] == null ? undefined : json['telefono'],
        'cellulare': json['cellulare'] == null ? undefined : json['cellulare'],
        'id': json['id'] == null ? undefined : json['id'],
        'hasUserId': json['hasUserId'] == null ? undefined : json['hasUserId'],
    };
}

export function OperatoreDTOToJSON(value?: OperatoreDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'enteId': value['enteId'],
        'nome': value['nome'],
        'cognome': value['cognome'],
        'codiceFiscale': value['codiceFiscale'],
        'nazioneId': value['nazioneId'],
        'regioneId': value['regioneId'],
        'provinciaId': value['provinciaId'],
        'comuneId': value['comuneId'],
        'regione': value['regione'],
        'provincia': value['provincia'],
        'comune': value['comune'],
        'email': value['email'],
        'telefono': value['telefono'],
        'cellulare': value['cellulare'],
        'id': value['id'],
        'hasUserId': value['hasUserId'],
    };
}

